var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"execution-steps"},[_c('ul',{staticClass:"execution-steps__list"},_vm._l((_vm.steps),function(step,idx){return _c('li',{key:step.title,staticClass:"execution-steps__item"},[_c('ExecutionStep',{attrs:{"title":step.title,"description":step.description,"icon-name":step.iconName,"order-number":idx + 1}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }